namespace Application.Services {
    'use strict';

    export class JsonService {
        public static $name: string = "jsonService";
        static $inject = ['$http', '$q'];
        constructor(private $http: ng.IHttpService, private $q: ng.IQService) {}

        readJson(json: string): ng.IPromise<any> {
            let deferred = this.$q.defer();
            this.$http.get(json).then((response) => {
                deferred.resolve(response.data);
            }, (error) => {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        writeJson(json: string, data: any): ng.IPromise<any> {
            let deferred = this.$q.defer();
            this.$http.post(json, data).then((response) => {
                deferred.resolve(response.data);
            }, (error) => {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        loadTemplateFile(): ng.IPromise<any>{
            return this.readJson('images/jsonTemplates/SRT_ext_template_service.json')
        }

        generateInformation(data:any):void{
            this.loadTemplateFile().then((template) => {
                this.setVirtualTS(data, template[0]);
                this.setVirtSrtRx(data, template[1]);
                this.setSrtGwTxLstn(data, template[2]);
                this.downloadFile(JSON.stringify(template),data.takerName.concat('_').concat(data.takerCore));
            }, (error) => {
                console.error('Error:', error);
            });
        }

        downloadFile(file: any, name:string): void {
            const blob = new Blob([file], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = name+'.json';
            a.click();
            URL.revokeObjectURL(url);
        }
        

        extractNumberFromString(str: string): string  {
            const regex = /\d+/;
            const match = str.match(regex);
            if (match) {
                return match[0];
            }
            return '';
        };

        getPadStart(number:string,width:number):string{
            let result:string=''
            for (let index = 0; index < width-number.length; index++) {
                result = result.concat('0');
            }
            return result;
        }

        getSequentialIp(ip:string, index:number):string{
            const ipArray = ip.split('.');
            ipArray[3]= (parseInt(ipArray[3])+index).toString();
            return ipArray.join('.');
        }

        setVirtualTS(data:any, template:any): void{

            let replacement = data.srtServer.concat(data.srtCoreNumber.replace('C','')).concat('VTS');
            template['name']=template['name'].replace('FR5A107VTS', replacement);
            template['mftSerialNumber'] = template['name'].replace('FR5A107VTS', replacement);
            template['config']['blockNames']['generatedBlockNames'].map((block:any) => {
                block['configAsJsonString']=block['configAsJsonString'].replace('FR5A107VTS', replacement);
            });
            
            replacement = data.takerName.concat('_').concat(data.takerCore);
            template['alias']=template['alias'].replace('HURTLK_C1', replacement);
            
            replacement = data.numberOfServices;
            template['config']['numberOfBlocks']=replacement;


            const servicesStartingNumberText:string = this.extractNumberFromString(data.servicesStartingNumber);
            const servicesStartingNumberPreffix:string = data.servicesStartingNumber.replace(servicesStartingNumberText, '');
            const servicesStartingNumberTextWidth:number = (parseInt(servicesStartingNumberText)+parseInt(data.numberOfServices)).toString().length;
            const blockReference = JSON.parse(JSON.stringify(template['config']['blockNames']['generatedBlockNames'][0]));
            template['config']['blockNames']['generatedBlockNames']=[]
            const idsArray:string[]=[];

            for (let index = 0; index < data.numberOfServices; index++) {
                const part1=servicesStartingNumberPreffix;
                const part2=this.getPadStart((parseInt(servicesStartingNumberText)+index).toString(),servicesStartingNumberTextWidth);
                const part3=(parseInt(servicesStartingNumberText)+index).toString();
                const part4=' '+data.takerName+' ';
                const part5=this.getPadStart((index+1).toString(),Math.max(2,(data.numberOfServices).toString().length))
                const part6=(index+1).toString();
                const id=part1.concat(part2).concat(part3).concat(part4).concat(part5).concat(part6);
                idsArray.push(id);
                const newBlockReference = JSON.parse(JSON.stringify(blockReference));
                newBlockReference['name']=id;
                newBlockReference['appIndex']=index+1;
                newBlockReference['blockIndex']=index;
                newBlockReference['configAsJsonString']=newBlockReference['configAsJsonString'].replace('\"index\":1', '\"index\":'+(index+1));
                newBlockReference['configAsJsonString']=newBlockReference['configAsJsonString'].replace('239.1.7.1', this.getSequentialIp(data.firstMulticastOfTheRange,index));
                template['config']['blockNames']['generatedBlockNames'].push(newBlockReference);
            }

            replacement = data.srtServer.concat('_MCAST');
            template['networkInterfaces'].map((block:any) => {
                block['name']=replacement;
            });

            template['searchText']['blocks']=idsArray.join(' ');

        }

        setVirtSrtRx(data:any, template:any): void{

            let replacement = data.srtServer.concat(data.srtCoreNumber.replace('C','')).concat('DEC');
            template['name']=template['name'].replace('FR5A107DEC', replacement);
            template['mftSerialNumber'] = template['name'].replace('FR5A107DEC', replacement);
            template['config']['blockNames']['generatedBlockNames'].map((block:any) => {
                block['configAsJsonString']=block['configAsJsonString'].replace('FR5A107DEC', replacement);
            });
            
            replacement = data.takerName.concat('_').concat(data.takerCore);
            template['alias']=template['alias'].replace('HURTLK_C1', replacement);
            
            replacement = data.numberOfServices;
            template['config']['numberOfBlocks']=replacement;

            const servicesStartingNumberText:string = this.extractNumberFromString(data.servicesStartingNumber);
            const servicesStartingNumberPreffix:string = data.servicesStartingNumber.replace(servicesStartingNumberText, '');
            const servicesStartingNumberTextWidth:number = (parseInt(servicesStartingNumberText)+parseInt(data.numberOfServices)).toString().length;
            const blockReference = JSON.parse(JSON.stringify(template['config']['blockNames']['generatedBlockNames'][0]));
            template['config']['blockNames']['generatedBlockNames']=[]
            const idsArray:string[]=[];

            for (let index = 0; index < data.numberOfServices; index++) {
                const part1=servicesStartingNumberPreffix;
                const part2=this.getPadStart((parseInt(servicesStartingNumberText)+index).toString(),servicesStartingNumberTextWidth);
                const part3=(parseInt(servicesStartingNumberText)+index).toString();
                const part4=' '+data.takerName+' ';
                const part5=this.getPadStart((index+1).toString(),Math.max(2,(data.numberOfServices).toString().length))
                const part6=(index+1).toString();
                const id=part1.concat(part2).concat(part3).concat(part4).concat(part5).concat(part6);
                idsArray.push(id);
                const newBlockReference = JSON.parse(JSON.stringify(blockReference));
                newBlockReference['name']=id;
                newBlockReference['appIndex']=index+1;
                newBlockReference['blockIndex']=index;
                newBlockReference['configAsJsonString']=newBlockReference['configAsJsonString'].replace('\"index\":1', '\"index\":'+(index+1));
                template['config']['blockNames']['generatedBlockNames'].push(newBlockReference);
            }

            template['searchText']['blocks']=idsArray.join(' ');

            

        }

        setSrtGwTxLstn(data:any, template:any): void{

            let replacement = data.srtServer.concat(data.srtCoreNumber.replace('C','')).concat('TXL');
            template['name']=template['name'].replace('FR5A107TXL', replacement);
            template['mftSerialNumber'] = template['name'].replace('FR5A107TXL', replacement);
            template['config']['blockNames']['generatedBlockNames'].map((block:any) => {
                block['configAsJsonString']=block['configAsJsonString'].replace('FR5A107TXL', replacement);
            });
            
            replacement = data.takerName.concat('_').concat(data.takerCore);
            template['alias']=template['alias'].replace('HURTLK_C1', replacement);
            
            replacement = data.numberOfServices;
            template['config']['numberOfBlocks']=replacement;

            replacement = data.srtCoreNumber.replace('C','');
            template['config']['cpusOffset']=parseInt(replacement);
            
            template['config']['processRtp2Udp']=data.protocol==='RTP'?false:true;
            
            template['config']['portRangeStart']=parseInt(data.firstSrtPortOfTheRange);

            const servicesStartingNumberText:string = this.extractNumberFromString(data.servicesStartingNumber);
            const servicesStartingNumberPreffix:string = data.servicesStartingNumber.replace(servicesStartingNumberText, '');
            const servicesStartingNumberTextWidth:number = (parseInt(servicesStartingNumberText)+parseInt(data.numberOfServices)).toString().length;
            const blockReference = JSON.parse(JSON.stringify(template['config']['blockNames']['generatedBlockNames'][0]));
            template['config']['blockNames']['generatedBlockNames']=[]
            const idsArray:string[]=[];

            for (let index = 0; index < data.numberOfServices; index++) {
                const part1=data.takerName;
                const part2='_'+data.takerCore;
                const part3='_'+data.srtCoreNumber;
                const part4='_'+servicesStartingNumberPreffix;
                const part5=this.getPadStart((index+1).toString(),Math.max(2,(data.numberOfServices).toString().length))
                const part6=(index+1).toString();

                const id=part1.concat(part2).concat(part3).concat(part4).concat(part5).concat(part6);
                idsArray.push(id);
                const newBlockReference = JSON.parse(JSON.stringify(blockReference));
                newBlockReference['name']=id;
                newBlockReference['appIndex']=index+1;
                newBlockReference['blockIndex']=index;
                newBlockReference['configAsJsonString']=newBlockReference['configAsJsonString'].replace('\"index\":1', '\"index\":'+(index+1));
                newBlockReference['configAsJsonString']=newBlockReference['configAsJsonString'].replace('\"SRT_PROCESS_RTP2UDP\":true', '\"SRT_PROCESS_RTP2UDP\":'+(data.protocol==='RTP'?false:true)+',\"SRT_PROCESS_RUNTIME\":\"'+data.srtProcessRuntime +'\"');
                newBlockReference['configAsJsonString']=newBlockReference['configAsJsonString'].replace('\"outputTargetPort\":\"41021\"', '\"outputTargetPort\":'+'\"'+(parseInt(data.firstSrtPortOfTheRange)+index)+'\"');
                template['config']['blockNames']['generatedBlockNames'].push(newBlockReference);
            }

            template['searchText']['blocks']=idsArray.join(' ');

            template['networkInterfaces'].filter((block:any) => block['name']==='mgt')[0].ipAddress=data.srtServerMgtIp;
            template['networkInterfaces'].filter((block:any) => block['name']==='int')[0].ipAddress=data.srtServerIntIp;
            template['networkInterfaces'].filter((block:any) => block['name']==='ext')[0].ipAddress=data.srtServerExtIp;

        }
    }
}